export var SyncType;
(function (SyncType) {
    SyncType["FULL_SYNC"] = "FULL_SYNC";
    SyncType["DAILY_SYNC"] = "DAILY_SYNC";
    SyncType["QUICK_SYNC"] = "QUICK_SYNC";
})(SyncType || (SyncType = {}));
